// extracted by mini-css-extract-plugin
module.exports = {"container":"CollageThumbnail_container__2Sn3H","thumbnail":"CollageThumbnail_thumbnail__3V57o"};